import React from 'react';
import { useI18n } from './i18n';

function TeaList({ sheets, onSelect }) {
  const { t, tc, formatDate, formatNumber } = useI18n();
  if (sheets.length === 0) {
    return <div className="empty-state">{t('tea.list.empty')}</div>;
  }

  return (
    <div className="sheets-list">
      <h2>{t('tea.list.title')}</h2>
      <div className="cards">
        {sheets.map((s) => (
          <div key={s.id} className="card" onClick={() => onSelect(s)}>
            <div className="card-header">
              <h3>{s.product_name}</h3>
              {s.harvest_year && <span className="vintage">{s.harvest_year}</span>}
            </div>
            <div className="card-body">
              {s.producer && <p>{s.producer}</p>}
              {s.tea_type && <p className="area">{tc('tea.type', s.tea_type)}{s.origin ? ` · ${s.origin}` : ''}</p>}
              {s.gbt_category && <p className="area">{tc('tea.gbt', s.gbt_category)}</p>}
              {s.weighted_score !== null && s.weighted_score !== undefined ? (
                <div className="card-score-final">{formatNumber(s.weighted_score, 1)}/100</div>
              ) : (s.total_score !== null && s.total_score !== undefined && (
                <div className="card-score-final">{formatNumber(s.total_score, 1)}/50</div>
              ))}
            </div>
            <div className="card-footer">
              {formatDate(s.tasting_date) || '—'} {s.taster ? `· ${s.taster}` : ''}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TeaList;
